import { FlexBox, Text, Tooltip } from '@dixa/lib-shared-habla';
import { ReactNode } from 'react';

type SatisfactionRatingReceivedMessageProps = {
  /** The score element component/content */
  scoreElement: ReactNode;
  /** Optional tooltip content for the rating */
  tooltipContent?: string;
  /** The type of rating (e.g., "CSAT", "NPS", "Thumbs") */
  ratingTypeLabel: string;
  /** The comment from the user */
  comment: string;
};

export const SatisfactionRatingReceivedMessage = ({
  scoreElement,
  tooltipContent,
  ratingTypeLabel,
  comment,
}: SatisfactionRatingReceivedMessageProps): JSX.Element => (
  <FlexBox
    alignItems="center"
    gap="300"
    padding="300"
    background="neutral.100"
    borderRadius="100"
  >
    <Tooltip content={tooltipContent} wrap="span">
      <Text.Paragraph variant="3">{scoreElement}</Text.Paragraph>
    </Tooltip>

    <FlexBox flexDirection="column" gap="200" flex="1">
      <Text.Paragraph variant="3">
        {ratingTypeLabel} rating received
      </Text.Paragraph>
      <Text.Paragraph>{comment || 'No comment'}</Text.Paragraph>
    </FlexBox>
  </FlexBox>
);
